(function () {
  'use strict';

  const COOKIE_NAME = 'shopify_recently_viewed';
  const MAX_SHOW = 6;
  const CARD_WIDTH = 140;

  // Chaînes traduites (FR/EN) lues depuis les data-attributes du conteneur,
  // rendues côté Liquid via `| t`. Valeurs ci-dessous = repli si jamais
  // le conteneur n'est pas trouvé.
  var STRINGS = {
    add: 'Ajouter',
    adding: 'Ajout...',
    added: 'Ajouté',
    soldOut: 'Épuisé',
    error: 'Erreur',
    unavailable: 'Indisponible',
    chooseOption: 'Choisir une option'
  };

  function loadStrings() {
    var section = document.getElementById('cart-recently-viewed');
    if (!section) return;
    var d = section.dataset;
    if (d.strAdd) STRINGS.add = d.strAdd;
    if (d.strAdding) STRINGS.adding = d.strAdding;
    if (d.strAdded) STRINGS.added = d.strAdded;
    if (d.strSoldOut) STRINGS.soldOut = d.strSoldOut;
    if (d.strError) STRINGS.error = d.strError;
    if (d.strUnavailable) STRINGS.unavailable = d.strUnavailable;
    if (d.strChooseOption) STRINGS.chooseOption = d.strChooseOption;
  }

  function readCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]).split(',').filter(Boolean) : [];
  }

  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.floor(cents / 100));
  }

  // Même correctif que cart-addon-collection.js : il faut avertir le
  // reste du thème (barre de livraison gratuite, popup cadeau Octobre
  // Rose) après un ajout, sinon rien ne réagit tant que le panier n'est
  // pas rafraîchi autrement.
  function dispatchCartChange(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: cart },
      bubbles: true
    }));
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(data => {
        // Shopify returns either {id:...} (single item) or {items:[...]} (batch)
        var success = data.id || (data.items && data.items.length > 0);
        if (success) {
          btn.textContent = '✓ ' + STRINGS.added;
          btn.style.background = '#2a7a4b';
          fetch('/cart.js').then(r => r.json()).then(cart => {
            document.querySelectorAll('[data-cart-count],[data-header-cart-count]').forEach(function(el) {
              el.textContent = cart.item_count;
              el.style.display = '';
            });
            // shop.money_format can (and here does) include real markup
            // (e.g. `<span class="money">${{amount}}</span>`) — it must be
            // formatted and inserted via innerHTML, not a raw cents number
            // via textContent, or the drawer shows literal "21484" or tags.
            document.querySelectorAll('[data-cart-final]').forEach(function(el) {
              el.innerHTML = formatMoney(cart.total_price);
            });
            document.querySelectorAll('[data-cart-bottom]').forEach(function(el) {
              el.classList.remove('cart--hidden');
            });
            dispatchCartChange(cart);
          });
          setTimeout(() => {
            btn.textContent = STRINGS.add;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        } else {
          btn.textContent = data.description || data.message || STRINGS.error;
          btn.disabled = false;
          setTimeout(() => { btn.textContent = STRINGS.add; }, 2500);
        }
      })
      .catch(() => {
        btn.textContent = STRINGS.error;
        btn.disabled = false;
        setTimeout(() => { btn.textContent = STRINGS.add; }, 2000);
      });
  }

  function buildCard(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const hasMultipleVariants = product.variants && product.variants.length > 1;
    const singleVariant = !hasMultipleVariants && product.variants && product.variants[0];
    const price = product.variants[0] ? product.variants[0].price : product.price;
    const compareAt = product.variants[0] ? product.variants[0].compare_at_price : null;

    const li = document.createElement('li');
    li.className = 'cart-rv__card';

    // Build variant options HTML
    let variantHtml = '';
    if (hasMultipleVariants) {
      const options = product.variants.map(v =>
        `<option value="${v.id}" ${!v.available ? 'disabled' : ''}>${v.title}${!v.available ? ' – ' + STRINGS.soldOut : ''}</option>`
      ).join('');
      variantHtml = `<select class="cart-rv__select" aria-label="${STRINGS.chooseOption}">${options}</select>`;
    }

    li.innerHTML = `
      <a href="/products/${product.handle}" class="cart-rv__card-img-link">
        <div class="cart-rv__card-img-wrap">
          ${image
            ? `<img src="${image}" alt="${product.title}" loading="lazy" class="cart-rv__card-img">`
            : '<div class="cart-rv__card-img cart-rv__card-img--placeholder"></div>'
          }
        </div>
      </a>
      <p class="cart-rv__card-title">
        <a href="/products/${product.handle}">${product.title}</a>
      </p>
      <p class="cart-rv__card-price">
        ${compareAt && compareAt > price
          ? `<span class="cart-rv__price-original">${formatMoney(compareAt)}</span> `
          : ''}
        <span class="cart-rv__price-final">${formatMoney(price)}</span>
      </p>
      ${variantHtml}
      <button class="cart-rv__add-btn" type="button" data-variant-id="${singleVariant ? singleVariant.id : ''}">
        ${STRINGS.add}
      </button>
    `;

    // Wire up the add button
    const btn = li.querySelector('.cart-rv__add-btn');
    const select = li.querySelector('.cart-rv__select');

    if (select) {
      // Update variant ID when selection changes
      select.addEventListener('change', () => {
        btn.dataset.variantId = select.value;
        const chosen = product.variants.find(v => v.id == select.value);
        if (chosen) {
          btn.disabled = !chosen.available;
          btn.textContent = chosen.available ? STRINGS.add : STRINGS.soldOut;
        }
      });
      // Set initial variantId from first option
      btn.dataset.variantId = select.value;
      const firstVariant = product.variants.find(v => v.id == select.value);
      if (firstVariant && !firstVariant.available) {
        btn.disabled = true;
        btn.textContent = STRINGS.soldOut;
      }
    } else if (singleVariant && !singleVariant.available) {
      btn.disabled = true;
      btn.textContent = STRINGS.soldOut;
    }

    btn.addEventListener('click', () => {
      const vid = btn.dataset.variantId;
      if (vid) addToCart(parseInt(vid), btn);
    });

    return li;
  }

  let loaded = false;

  async function loadRecentlyViewed() {
    const section = document.getElementById('cart-recently-viewed');
    if (!section) return;

    const handles = readCookie(COOKIE_NAME).slice(0, MAX_SHOW);
    if (handles.length === 0) return;

    // Don't reload if already populated
    const track = section.querySelector('#cart-rv-track');
    if (track.children.length > 0) {
      section.style.display = 'block';
      return;
    }

    const results = await Promise.allSettled(
      handles.map(handle =>
        fetch(`/products/${handle}.js`)
          .then(r => r.ok ? r.json() : null)
          .catch(() => null)
      )
    );

    let added = 0;
    results.forEach(r => {
      if (r.status === 'fulfilled' && r.value) {
        track.appendChild(buildCard(r.value));
        added++;
      }
    });

    if (added > 0) {
      section.style.display = 'block';
      initCarousel(section);
    }
  }

  function initCarousel(section) {
    const wrapper = section.querySelector('.cart-rv__track-wrapper');
    const prevBtn = section.querySelector('.cart-rv__arrow--prev');
    const nextBtn = section.querySelector('.cart-rv__arrow--next');

    function updateArrows() {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      prevBtn.disabled = wrapper.scrollLeft <= 2;
      nextBtn.disabled = wrapper.scrollLeft >= maxScroll - 2;
      prevBtn.style.opacity = prevBtn.disabled ? '0.3' : '1';
      nextBtn.style.opacity = nextBtn.disabled ? '0.3' : '1';
    }

    prevBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: -(CARD_WIDTH + 12) * 2, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: (CARD_WIDTH + 12) * 2, behavior: 'smooth' });
    });
    wrapper.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  // Watch for cart drawer opening
  document.addEventListener('DOMContentLoaded', () => {
    loadStrings();

    const drawer = document.getElementById('drawer-cart');
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      if (drawer.classList.contains('drawer--visible') || drawer.classList.contains('is-open')) {
        loadRecentlyViewed();
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Also try on load in case drawer is already open
    loadRecentlyViewed();
  });

})();
